<template>
  <div>
    <buttons-group
        :items="items"
        :indexStep="index"
        :disabledAll="disabled"
        @click="getIndex"
    />
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      items: [
        { label: 'Dados Cadastrais', sublabel: '' },
        { label: 'Classificação', sublabel: '' },
        { label: 'Hierarquia', sublabel: '' },
        { label: 'Endereço', sublabel: '' },
        { label: 'Contatos', sublabel: 'Para atendimento ao Beneficiário' }
      ],
      disabled: true
    }
  },
  methods: {
    getIndex (index) {
      this.disabled = false
      this.$emit('changeButton', index)
    },
    changeDisabled () {
      this.disabled = true
    }
  }
}
</script>